import Service from "../../AuthService";
const FactorialMaterialImport = {
    getFactorialMaterialImport(page) {
        return Service.get("/factorial-material-import?page="+page);
    },
    showFactorialMaterialImport(id) {
        return Service.get("/factorial-material-import/" + id);
    },
    updateFactorialMaterialImport(id, data) {
        return Service.put("/factorial-material-import/" + id, data);
    },
    createFactorialMaterialImport(data) {
        return Service.post("/factorial-material-import", data);
    },
    deleteFactorialMaterialImport(id) {
        return Service.delete("/factorial-material-import/" + id);
    },
    searchFactorialMaterialImport(data){
        return Service.post('/search-factorial-material-import',data);
    },
};
export default FactorialMaterialImport;
